<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <table class="table">
          <table-row label="Image" :noBorder="true">
            <v-lazy-image
              v-if="deviceAccessory.image"
              :src="deviceAccessory.image"
              class="img-fluid"
              style="max-height: 100px"
            />
          </table-row>

          <table-row label="Code">
            {{ deviceAccessory.code }}
          </table-row>

          <table-row label="Description">
            {{ deviceAccessory.description }}
          </table-row>

          <table-row v-if="deviceAccessory.device_type" label="Device Type">
            {{ deviceAccessory.device_type.description }}
            <router-link
              v-b-tooltip.hover
              title="view"
              :to="{
                name: 'device-types-show',
                params: { id: deviceAccessory.device_type.id },
              }"
              class="text-info"
            >
              <i class="lni lni-search-alt"></i>
            </router-link>
          </table-row>

          <table-row icon="lni-database" :noBorder="true"/>

          <table-row label="Id">
            {{ deviceAccessory.id }}
          </table-row>

          <table-row label="Created">
            {{
              moment(new Date(deviceAccessory.created_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
          <table-row label="Updated">
            {{
              moment(new Date(deviceAccessory.updated_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import deviceAccessoryRepo from "@/api/repos/deviceAccessoryRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getDeviceAccessory();
  },

  data() {
    return {
      loading: false,
      deviceAccessory: {},
    };
  },

  methods: {
    async getDeviceAccessory() {
      try {
        this.loading = true;
        let { data } = await deviceAccessoryRepo.get(this.id);
        this.deviceAccessory = data.device_accessory;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
